import {combineReducers} from "redux";
import comment from "features/components/comment-field/reducer";
import suggest from "features/components/comment-field/comment-autosuggest/reducer";
import list from "features/components/comment-box/reducer";
import del from "./delete/reducer";
import edit from "features/modals/comment-edit/reducer";
import vote from "./vote/reducer";

export default combineReducers({
    comment,
    suggest,
    list,
    delete: del,
    edit,
    vote
})